import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import intersect from '@alpinejs/intersect';

import AsyncForm from './components/async-form';
import AuditOrder from './components/audit-order';
import Blog from './components/blog';
//import BookStore from './components/bookstore';
//import Carousel from './components/carousel';
import Cart from './components/cart';
//import ClosestEvents from './components/closest-events';
import CourseComparator from './components/course-comparator';
//import CourseReviews from './components/course-reviews';
//import Dictionary from './components/dictionary';
import EventsRow from './components/events-row';
import EventsTable from './components/events-table';
import FaqSearch from './components/faq-search';
//import FlyingButton from './components/flying-button';
//import LastSeen from './components/last-seen';
//import Order from './components/order';
import Modal from './components/modal';
import NavCart from './components/nav-cart';
//import Search from './components/search';
//import Tabs from './components/tabs';
import StickyObserver from './components/sticky-observer';
import Testimonials from './components/testimonials';
//import VimeoPlayer from './components/vimeo-player';
import VimeoThumbnail from './components/vimeo-thumbnail';
//import ZoomOnScroll from './components/zoom-on-scroll';
//import TextareaAutoheight from './components/textarea-autoheight';

const BASE_URL_METHODICS = '/api/taxonomies/methodics/terms';
const BASE_URL_AUDITS = '/api/collections/audits/entries';

window.Alpine = Alpine;

Alpine.plugin(persist);
Alpine.plugin(intersect);

Alpine.data('asyncForm', AsyncForm);
Alpine.data('auditOrder', AuditOrder);
Alpine.data('blog', Blog);
//Alpine.data('bookstore', BookStore);
//Alpine.data('carousel', Carousel);
Alpine.data('cart', Cart);
//Alpine.data('closestEvents', ClosestEvents);
Alpine.data('courseComparator', CourseComparator);
//Alpine.data('courseReviews', CourseReviews);
//Alpine.data('dictionary', Dictionary);
Alpine.data('eventsTable', EventsTable);
Alpine.data('faqSearch', FaqSearch);
//Alpine.data('flyingButton', FlyingButton);
//Alpine.data('lastSeen', LastSeen);
Alpine.data('modal', Modal);
Alpine.data('navCart', NavCart);
//Alpine.data('order', Order);
Alpine.data('row', EventsRow);
//Alpine.data('search', Search);
//Alpine.data('tabs', Tabs);
Alpine.data('stickyObserver', StickyObserver);
Alpine.data('testimonials', Testimonials);
//Alpine.data('textareaAutoheight', TextareaAutoheight);
//Alpine.data('vimeoPlayer', VimeoPlayer);
Alpine.data('vimeoThumbnail', VimeoThumbnail);
//Alpine.data('zoomOnScroll', ZoomOnScroll);

Alpine.store('events', {
  events: [],
  dataFetched: false,

  set(events) {
    this.events = events;
    this.dataFetched = true;
  },

  get() {
    return this.events;
  },

  hasEvents() {
    return this.events.length > 0;
  },
});

Alpine.store('methodics', {
  filter: {
    query: '',
    methodics: [],
    role: '',
    tags: [],
    site: document.querySelector('html').getAttribute('lang'),
  },
  tags: [],
  dataFetched: false,
  loading: false,
  data: [],
  extraData: [],
  isLoadingMore: false,
  page: 1,
  totalPages: 0,
  initialLimit: 12,

  get filterActivated() {
    return this.filter.query.length > 2 ||
           this.filter.methodics.length > 0 ||
           this.filter.role.length > 0 ||
           this.filter.tags.length > 0;
  },

  get canLoadMore() {
    return this.totalPages === 0 || this.page < this.totalPages;
  },

  filterData(filter) {
    this.filter = filter;
    this.getData(filter);
  },

  get methodicFilterQuery() {
    return this.filter.methodics.length
      ? `&filter[id:in]=${this.filter.methodics.join('|')}`
      : '';
  },

  get roleFilterQuery() {
    return this.filter.role.length
      ? `&filter[role:contains]=${this.filter.role}`
      : '';
  },

  get tagFilterQuery() {
    return this.filter.tags.length
      ? `&filter[tags:in]=${this.filter.tags.join('|')}`
      : '';
  },

  get siteFilterQuery() {
    return this.filter.site.length
      ? `&filter[site:is]=${this.filter.site}`
      : '';
  },

  get stringQuery() {
    return this.filter.query.length > 2
      ? `&filter[title:contains]=${this.filter.query.replace(
        /[^a-zA-Z ]/g,
        ''
      )}`
      : '';
  },

  resetFilter() {
    this.filter.query = '';
    this.filter.methodics = [];
    this.filter.role = '';
    this.filter.tags = [];
    this.data = [];
    this.extraData = [];
    this.isLoadingMore = false;
    this.page = 1;
    this.totalPages = 0;
  },

  getTags() {
    this.getData().then(() => {
      const tagSet = new Set();
      this.data.forEach((item) => {
        const tagString = JSON.stringify(item.tags);
        if (tagString !== 'null') {
          tagSet.add(tagString);
        }
      });
      if (this.tags.length === 0) {
        this.tags = Array.from(tagSet).map((tagString) =>
          JSON.parse(tagString)
        );
      }
      return this.tags;
    });
  },

  getData() {
    this.loading = true;

    return fetch(
      `${BASE_URL_METHODICS}?filter[active:is]=true&limit=1000&sort=title${
        this.methodicFilterQuery +
        this.roleFilterQuery +
        this.stringQuery +
        this.tagFilterQuery +
        this.siteFilterQuery
      }&fields=url,title,top,tags,card_image,icon,alternative_title,card_text`
    )
      .then((response) => response.json())
      .then((response) => {
        this.data = response.data;
        this.loading = false;
      });
  },

  loadMore() {
    if (this.loading) {
      return;
    }

    if (this.totalPages !== 0 && this.page >= this.totalPages) {
      return;
    }

    this.loading = true;
    this.isLoadingMore = true;
    const nextPage = this.page + 1;

    return fetch(
      `${BASE_URL_METHODICS}?filter[active:is]=true&limit=${this.initialLimit}&page=${nextPage}&sort=title${this.siteFilterQuery}&fields=url,title,top,tags,card_image,icon,alternative_title,card_text`
    )
      .then((response) => response.json())
      .then((response) => {
        const newData = response.data || [];
        const lastPage =
          response.meta && response.meta.last_page ? response.meta.last_page : nextPage;

        this.extraData = this.extraData.concat(newData);
        this.page = Math.min(nextPage, lastPage);
        this.totalPages = lastPage;
        this.loading = false;
        this.isLoadingMore = false;
      })
      .catch(() => {
        this.loading = false;
        this.isLoadingMore = false;
      });
  },
});

Alpine.store('audits', {
  filter: {
    query: '',
    category: [],
    fields: [],
  },
  dataFetched: false,
  loading: false,
  data: [],
  tags: [],

  get filterActivated() {
    return this.filter.query.length > 2 ||
           this.filter.category.length > 0 ||
           this.filter.fields.length > 0;
  },

  filterData(filter, category = null) {
    this.filter = filter;
    this.getData(filter, category);
  },

  resetFilter() {
    this.filter.query = '';
    this.filter.category = [];
    this.filter.fields = [];
  },

  get fieldsFilterQuery() {
    return this.filter.fields.length
      ? `&filter[taxonomy:fields:in]=${this.filter.fields}`
      : '';
  },

  get stringQuery() {
    return this.filter.query.length > 2
      ? `&filter[title:contains]=${this.filter.query}`
      : '';
  },

  get categoryQuery() {
    const categories = this.filter.category.join(',');
    return this.filter.category.length !== 0
      ? `&filter[taxonomy:audits_categories:in]=${categories}`
      : '';
  },

  getTags() {
    this.getData('').then(() => {
      const tagSet = new Set();
      this.data.forEach((item) => {
        item.audits_categories.forEach((category) => {
          const tagString = JSON.stringify(category);
          if (tagString !== 'null') {
            tagSet.add(tagString);
          }
        });
      });
      if (this.tags.length === 0) {
        this.tags = Array.from(tagSet).map((tagString) =>
          JSON.parse(tagString)
        );
      }
      return this.tags;
    });
  },

  getData(filter) {
    this.loading = true;
    return fetch(
      `${BASE_URL_AUDITS}?filter[published:is]=true&sort=title&filter[site]=cs${
        this.fieldsFilterQuery + this.stringQuery + this.categoryQuery
      }`
    )
      .then((response) => response.json())
      .then((response) => {
        this.data = response.data;
        this.loading = false;
      });
  },
});

Alpine.start();
